import { put } from "redux-saga/effects";
import { loginv2, verifyOtp, resendOtp, getCaptchaV2 } from "../../Services";

export function* loginV2Saga(action) {
  const { payload } = action;

  try {
    const res = yield loginv2(payload.data);

    if (res.data.code !== "00") {
      payload.cb(false);
      return yield put({ type: "REQ_LOGIN_V2_FAILED", errData: res.data });
    }

    if (!res.data.name) {
      if (res.data.verified) {
        localStorage.setItem("Authorization", res.headers.authorization);
        // console.log("login data....", res.data);
        localStorage.setItem("LoginData", JSON.stringify(res.data));
        yield put({ type: "LOGIN" });
        yield put({ type: "REQ_LOGIN_V2_SUCCEEDED", data: res.data });
        yield put({ type: "VERIFY_OTP_SUCCEEDED", data: res.data });
        payload.cb(true);
        return;
      }
      yield put({ type: "REQ_LOGIN_V2_SUCCEEDED", data: res.data });
      payload.cb(true);
      return;
    }
    yield put({ type: "REQ_LOGIN_V2_FAILED", errData: res.data });
    payload.cb(false);
  } catch (e) {
    yield put({ type: "REQ_LOGIN_V2_FAILED", errData: e });
    payload.cb(false);
  }
}

export function* resendOTPSaga(action) {
  const { payload } = action;
  try {
    const res = yield resendOtp(payload.data);
    yield put({ type: "RESEND_OTP_SUCCEEDED", data: res.data });
    payload.cb(true);
  } catch (e) {
    yield put({ type: "RESEND_OTP_FAILED", errData: e });
    payload.cb(false);
  }
}

export function* verifyOtpSaga(action) {
  const { payload } = action;
  try {
    const res = yield verifyOtp(payload);
    if (!res.data.name) {
      localStorage.setItem("Authorization", res.headers.authorization);
      localStorage.setItem("LoginData", JSON.stringify(res.data));
      yield put({ type: "LOGIN" });
      yield put({ type: "VERIFY_OTP_SUCCEEDED", data: res.data });
      console.log("verify OTP success....");
      payload.cb(true);
      return;
    }
    yield put({ type: "VERIFY_OTP_FAILED", errData: res.data });
    payload.cb(false);
  } catch (e) {
    yield put({ type: "VERIFY_OTP_FAILED", errData: e });
    payload.cb(false);
  }
}

export function* logoutV2Saga(action) {
  const { payload } = action;
  try {
    localStorage.removeItem("Authorization");
    localStorage.removeItem("LoginData");

    yield put({ type: "REQ_LOGOUT_V2_SUCCEEDED", data: payload });
  } catch (e) {
    console.log("LOGOUT GAGAL");
  }
}

export function* getCaptchaV2Saga(action) {
  const { payload } = action;
  try {
    const res = yield getCaptchaV2(payload);
    yield put({ type: "REQ_CAPTCHA_SVG_V2_SUCCEEDED", data: res });
  } catch (e) {
    yield put({ type: "REQ_CAPTCHA_SVG_V2_FAILED", errData: e });
  }
}
